import BlogPost from "./BlogPost";
import { getResource } from "../lib/api";

export default function ResourceDetail() {
  return (
    <BlogPost
      fetcher={getResource}
      basePath="/resources"
      backLabel="Back to resources"
      relatedLabel="Related resources"
    />
  );
}
